export default "__VITE_ASSET__B0xlpw3g__"